import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { storeAppVersion, fetchAppVersion } from "@/lib/cacheManager";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ─── App version bootstrap ────────────────────────────────────────────────────
// Fetch and store the current server version on every fresh page load so
// isVersionOutdated() has a baseline to compare against.
fetchAppVersion()
  .then((v) => { if (v?.version) storeAppVersion(v.version); })
  .catch(() => { /* non-critical */ });

// ─── Service Worker registration ──────────────────────────────────────────────
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // ── Detect when a new SW has been installed and is waiting ──────────
        const onUpdateFound = () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            // A new SW is installed and the old one is still controlling the page
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // Dispatch a custom event so any React component can listen
              // and show an "Update available — refresh" banner.
              window.dispatchEvent(
                new CustomEvent("sw:update-available", {
                  detail: { registration },
                })
              );
              console.info("[SW] New version available. Waiting for user to reload.");
            }
          });
        };

        // Fire for updates that arrive after initial registration
        registration.addEventListener("updatefound", onUpdateFound);

        // ── Reload all open tabs when the new SW takes control ─────────────
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (!refreshing) {
            refreshing = true;
            console.info("[SW] New service worker activated — reloading.");
            window.location.reload();
          }
        });

        // ── Listen for messages posted by the SW ───────────────────────────
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data?.type === "CACHE_CLEARED") {
            console.info("[SW] Cache cleared by service worker.");
          }
        });

        // ── Check for waiting updates on page focus (catches stale tabs) ───
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            registration.update().catch(() => {});
          }
        });
      })
      .catch((err) => {
        // SW is best-effort — log but never crash the app
        console.warn("[SW] Registration failed:", err);
      });
  });
}
